export default "__VITE_ASSET__szXh8Eto__"